import React, { useState } from 'react';
import { useMutation, useQueryClient } from 'react-query';
import { useNavigate } from 'react-router-dom';
import api from '../services/api';
import { toast } from 'react-toastify';
import { routes } from '../lib/routes';
import './Login.css';

export default function Login() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const navigate = useNavigate();
  const queryClient = useQueryClient();

  const loginMutation = useMutation(
    () => api.post('/auth/login', { email, password }).then(r => r.data),
    {
      onSuccess: (data) => {
        localStorage.setItem('token', data.token);
        queryClient.setQueryData('me', data.user);
        navigate(routes.dashboard, { replace: true });
        toast.success('Login realizado com sucesso!');
      },
      onError: (error) => {
        const status = error.response?.status;
        const apiMsg = error.response?.data?.error;
        let msg = apiMsg;
        if (!msg && status === 502) {
          msg = 'Serviço temporariamente indisponível. A API não está respondendo (erro 502).';
        } else if (!msg && !error.response) {
          msg = 'Não foi possível conectar ao servidor. Verifique se a API está no ar.';
        }
        toast.error(msg || 'Credenciais inválidas');
      }
    }
  );

  const handleSubmit = (event) => {
    event.preventDefault();
    loginMutation.mutate();
  };

  return (
    <div className="login-page">
      <header className="login-site-header">
        <a className="login-site-brand" href="/SisPro">
          <span className="login-site-badge">SP</span>
          <div>
            <strong>SisPro</strong>
            <span>Protocolo Eletronico de Projetos</span>
          </div>
        </a>
        <a className="login-site-outline" href="/SisPro">
          Pagina institucional
        </a>
      </header>

      <div className="login-grid">
        <section className="login-brand-panel">
          <h1>SisPro</h1>
          <p>
            Plataforma de protocolo eletronico para abertura, analise e acompanhamento
            de processos de aprovacao de projetos.
          </p>
          <ul>
            <li>Tramitacao digital com rastreabilidade</li>
            <li>Gestao de documentos e revisoes tecnicas</li>
            <li>Operacao integrada com fluxos administrativos</li>
          </ul>
        </section>

        <section className="login-form-panel">
          <div className="login-form-header">
            <h2>Acesso ao Sistema</h2>
            <p>Informe suas credenciais para continuar.</p>
          </div>

          <form className="login-form" onSubmit={handleSubmit}>
            <label htmlFor="email">E-mail</label>
            <input
              id="email"
              type="email"
              placeholder="seuemail@dominio.gov.br"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />

            <label htmlFor="password">Senha</label>
            <input
              id="password"
              type="password"
              placeholder="Digite sua senha"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />

            <button type="submit" className="sispro-btn sispro-btn--primary login-form-submit" disabled={loginMutation.isLoading}>
              {loginMutation.isLoading ? 'Autenticando...' : 'Entrar no sistema'}
            </button>
          </form>

          <p className="login-support">Suporte tecnico: atendimento@lorenadigital.com.br</p>
        </section>
      </div>
    </div>
  );
}
